import { createSafeContext } from '@lib/utils/createSafeContext';

export type LocaleCode = string;
export type Dir = 'ltr' | 'rtl';

export interface LocaleContextType {
  locale: LocaleCode;
  updateLocale: (newLocale: LocaleCode) => Promise<void>;
  direction: Dir;
  setDirection: (dir: Dir) => void;
  isRtl: boolean;
}

export const [LocaleContext, useLocaleContext] = createSafeContext<LocaleContextType>(
  'useLocaleContext must be used within LocaleProvider'
);
